import React from 'react';

import Drawer from './index';
import Header from './components/Header';
import Notifications from './components/notifications/Notifications';

import notificationsImg from '~images/Paketti-ikonit-ilmoitukset.svg';

const NotificationsDrawer = () => {
  return (
    <Drawer name="notifications">
      <Header title="Ilmoitukset" headerImg={notificationsImg} />
      <Notifications />
    </Drawer>
  );
};

export default NotificationsDrawer;
